import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import CorporateListComponent from "./component";
import { useNavigate } from "react-router-dom";

const CorporateListContainer = (props) => {
  const navigate = useNavigate();
  const [corporateList, setCorporateList] = useState([]);
  const [filteredCorporateList, setFilteredCorporateList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const tableContainerRef = useRef(null);

  const handleSearchInputChange = (event) => {
    const inputValue = event.target.value;
    setSearchValue(inputValue);
  };

  const handleCreateCorporate = () => {
    navigate("/home/customermanager/create-corporate");
  };

  const handleConfiguration = (corporateId) => {
    navigate(`/home/customermanager/corporate-configuration/${corporateId}`);
  };

  const handleAction = (corporateId) => {
    // Handle action (e.g., view details, edit, etc.)
    console.log("Action clicked for corporate:", corporateId);
    navigate(`/home/customermanager/corporate-details/${corporateId}`);
  };

  useEffect(() => {
    handleFilterCorporate();
  }, [searchValue, corporateList]);

  // Handle infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      const container = tableContainerRef.current;
      if (container && !isLoadingMore && hasMore) {
        const { scrollTop, clientHeight, scrollHeight } = container;
        if (scrollTop + clientHeight >= scrollHeight - 100) {
          loadMoreCorporates();
        }
      }
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [isLoadingMore, hasMore]);

  useEffect(() => {
    handleGetCorporates();
  }, []);

  const loadMoreCorporates = () => {
    if (!isLoadingMore && hasMore) {
      handleGetCorporates(true);
    }
  };

  const handleGetCorporates = (isLoadMore = false) => {
    if (isLoadMore) {
      setIsLoadingMore(true);
    } else {
      setLoading(true);
      setPageNumber(0);
      setCorporateList([]);
    }

    const currentPage = isLoadMore ? pageNumber + 1 : 0;

    props.getDataFromAPI(
      `/partner/api/v2/corporates?page=${currentPage}&size=20`,
      "GET",
      undefined,
      (response) => {
        console.log("API Response:", response);

        let corporateData = [];
        let totalPages = 0;
        let currentPageNumber = 0;

        if (response?.data?.content && Array.isArray(response.data.content)) {
          corporateData = response.data.content;
          totalPages = response.data.totalPages || 0;
          currentPageNumber = response.data.number || 0;
        } else if (response?.content && Array.isArray(response.content)) {
          corporateData = response.content;
          totalPages = response.totalPages || 0;
          currentPageNumber = response.number || 0;
        } else if (Array.isArray(response)) {
          corporateData = response;
        } else if (response?.data && Array.isArray(response.data)) {
          corporateData = response.data;
        }

        // Format the data
        const formattedCorporates = corporateData.map(corp => ({
          corporateId: corp.corporateId,
          corporateName: corp.corporateName,
          totalUsers: corp.totalUsers || 0,
          totalDepartments: corp.totalDepartments || 0,
          totalRules: corp.totalRules || 0,
          totalTags: corp.totalTags || 0,
          hasBPTag: corp.totalTags > 0 // Determine if BP Tag exists
        }));

        if (isLoadMore) {
          setCorporateList(prevList => [...prevList, ...formattedCorporates]);
          setPageNumber(currentPageNumber);
        } else {
          setCorporateList(formattedCorporates);
          setPageNumber(currentPageNumber);
        }

        setHasMore(currentPageNumber + 1 < totalPages);
        setLoading(false);
        setIsLoadingMore(false);
      },
      (err) => {
        console.log("Error fetching corporates:", err);
        toastr.error("Failed", "Unable to fetch corporate list");
        setLoading(false);
        setIsLoadingMore(false);
      }
    );
  };

  const handleFilterCorporate = () => {
    if (!searchValue.trim()) {
      setFilteredCorporateList(corporateList);
      return;
    }

    const filteredList = corporateList.filter((corporate) => {
      const searchString = searchValue.toLowerCase();
      const corporateId = (corporate.corporateId || "").toString().toLowerCase();
      const corporateName = (corporate.corporateName || "").toLowerCase();
      return corporateId.includes(searchString) || corporateName.includes(searchString);
    });
    setFilteredCorporateList(filteredList);
  };

  return (
    <CorporateListComponent
      filteredCorporateList={filteredCorporateList}
      tableContainerRef={tableContainerRef}
      handleSearchInputChange={handleSearchInputChange}
      handleFilterCorporate={handleFilterCorporate}
      handleCreateCorporate={handleCreateCorporate}
      handleConfiguration={handleConfiguration}
      handleAction={handleAction}
      loading={loading}
      searchValue={searchValue}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
    />
  );
};

function mapStateToProps(state) {
  return {
    props: state,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(CorporateListContainer);